"use client";

import React from "react";
import { CircleCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function TransformeConteudoEmAprendizado() {
  return <section data-section-id="16443" id="sua-próxima-jornada-com-elegância" className="relative w-full overflow-hidden bg-background pt-12 pb-10 lg:pt-16 lg:pb-12 isolate">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none z-0">
        <div className="absolute top-20 right-0 w-[500px] h-[500px] bg-secondary/5 rounded-lg blur-3xl opacity-50 mix-blend-multiply animate-pulse" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-primary/10 rounded-lg blur-3xl opacity-40 mix-blend-multiply" />
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="grid gap-12 grid-cols-1 items-center">
          
          <div className="relative w-full max-w-[90%] mx-auto opacity-100 translate-x-0">
            <div className="relative aspect-[4/5] md:aspect-[21/7] w-full group">
              <div className="absolute inset-0 rounded-3xl bg-linear-to-br from-secondary/5 to-primary/5 border border-white/20 backdrop-blur-sm shadow-2xl overflow-hidden">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/machu-picchu-cidade-perdida-incas-peru.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/machu-picchu-cidade-perdida-incas-peru.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/machu-picchu-cidade-perdida-incas-peru.webp-wvc-sizes" alt="Vista panorâmica de Machu Picchu com nuvens, Peru" width={2100} height={700} loading="eager" fetchPriority="high" className="w-full h-full object-cover aspect-[4/5] md:aspect-[21/7]" />
              </div>
            </div>
          </div>

          
          <div className="flex flex-col justify-center items-center space-y-8 opacity-100 translate-y-0">
            <div className="space-y-4 flex flex-col items-center">
              <h1 className="text-5xl font-default font-bold tracking-tight text-foreground sm:text-6xl xl:text-7xl/none text-center">
                Experiências de Viagem{" "}
                <span className="relative inline-block !text-[rgba(27,164,172,1)]">
                  Pelo Mundo
                  <svg className="absolute w-full h-3 -bottom-1 left-0 text-primary -z-10" viewBox="0 0 100 10" preserveAspectRatio="none">
                    <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="8" fill="none" />
                  </svg>
                </span>
              </h1>

              <p className="max-w-[650px] font-default text-lg sm:text-xl leading-relaxed text-foreground text-center lg:line-clamp-2">
                Sinta o máximo conforto e suporte com planejamento personalizado para suas próximas férias inesquecíveis em destinos exclusivos.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
              <Button asChild size="lg" className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive h-10 has-[>svg]:px-4 text-white border-0 shadow-lg shadow-primary/20 transition-transform rounded-lg px-8 !bg-[#B35900] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:!bg-[#8E460B] hover:scale-105">
                <Link to="https://wa.me/5548988221618">Falar no WhatsApp</Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="border-secondary/20 text-[#2F7471] hover:bg-secondary/5 hover:text-[#2F7471] transition-all rounded-lg">
                <Link to="https://www.kgviagens.com/quem-somos/">Saiba Mais</Link>
              </Button>
            </div>

            <div className="flex items-center gap-4 text-sm text-muted-foreground font-default">
              <div className="flex items-center gap-1.5">
                <CircleCheck className="h-4 w-4 text-secondary" />
                <span className="text-foreground">Roteiros Exclusivos</span>
              </div>
              <div className="h-1 w-1 rounded-lg bg-border" />
              <div className="flex items-center gap-1.5">
                <CircleCheck className="h-4 w-4 text-secondary" />
                <span className="text-foreground">Suporte Personalizado</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}